module.exports = {

  title: '弘善庆堂互联网医院',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   * @description 是否固定头部导航栏
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   * @description 是否在侧边栏中显示徽标
   */
  sidebarLogo: true
}
